export default {
  name: 'plum',

  anchor: '#1034a6',
  anchorVisited: '#440381',
  borderDark: '#7b5f5b',
  borderDarkest: '#050608',
  borderLight: '#c3b1aa',
  borderLightest: '#e8dad6',
  canvas: '#dad0c7',
  canvasText: '#050608',
  canvasTextDisabled: '#7b5f5b',
  canvasTextDisabledShadow: '#e8dad6',
  canvasTextInvert: '#e8dad6',
  checkmark: '#050608',
  checkmarkDisabled: '#7b5f5b',
  flatDark: '#9e9e9e',
  flatLight: '#d8d8d8',
  focusSecondary: '#fefe03',
  headerBackground: '#483f63',
  headerNotActiveBackground: '#7d5e58',
  headerNotActiveText: '#e8dad6',
  headerText: '#ffffff',
  hoverBackground: '#483f63',
  material: '#ac978f',
  materialDark: '#9a9e9c',
  materialText: '#050608',
  materialTextDisabled: '#7b5f5b',
  materialTextDisabledShadow: '#e8dad6',
  materialTextInvert: '#ffffff',
  progress: '#483f63',
  tooltip: '#fefbcc'
};
